const elemSearchBox = document.querySelectorAll('.tcms_searchBox_widget');
window.fireOnVisible(elemSearchBox, async () => {
    await import('./import.toggled.js').catch((err) => {
        console.error(new Error('Toggled Form asset could not be loaded.'));
        console.error(err);
    });
});
